<template>
  <div v-if="about">
    <h3 class="mb-5">Corporate Introduction</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <div>
      <!-- Title -->
      <label class="form-item d-flex py-5">
        <h4 class="w-180px">Title</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ about.corporate_title }}
        </div>
      </label>
      <!-- Content -->
      <label class="form-item d-flex py-5">
        <h4 class="w-180px">SubTitle</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ about.corporate_subtitle }}
        </div>
      </label>
      <!-- img uploader -->
      <div class="px-5 py-5 d-flex">
        <div class="w-180px">
          <h4 class="mb-10px">Visual</h4>
        </div>
        <div class="flex-grow-1">
          <div
            class="w-305px h-187px bg-cover bg-center ml-auto"
            :style="{
              'background-image': `url(${about.corporate_visual})`,
              'border-radius': '6.2px',
              'background-size': 'contain',
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
